import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Tooltip } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { workflowApi } from '../../utils/api';

/**
 * نشانگر تعداد موارد در انتظار تأیید در هدر
 */
const WorkflowPendingBadge = ({ isDarkMode = false }) => {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const res = await workflowApi.getPendingApprovals({ page: 1, per_page: 1 });
      const meta = res?.meta || res?.data?.meta || {};
      const total = meta.total;
      if (total != null) {
        setCount(Number(total) || 0);
        return;
      }
      const list = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
          ? res.data.data
          : [];
      setCount(list.length);
    } catch {
      /* silent — badge optional */
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <Tooltip title="کارتابل تأییدات">
      <Link
        to="/workflow/inbox"
        className={`
          relative flex items-center justify-center w-10 h-10 rounded-lg transition-all
          ${isDarkMode
            ? 'text-gray-300 hover:bg-[rgba(13,136,126,0.14)] hover:text-white'
            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}
        `}
        aria-label="کارتابل تأییدات"
      >
        <Badge count={count} overflowCount={99} size="small" offset={[-2, 2]}>
          <InboxOutlined className="text-lg" />
        </Badge>
      </Link>
    </Tooltip>
  );
};

export default WorkflowPendingBadge;
